import { COLOR } from '@src/styles/color';
import styled from 'styled-components';

export const ItemContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const BulletWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 20px;
`;

export const ItemText = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #1c1c1e;
`;

export const BoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 8px;
  padding: 16px 12px;
  background-color: rgba(244, 245, 247, 0.8);
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 700;
  gap: 8px;
  justify-content: space-between;
  margin-top: ${({ comparisonMode }) => (comparisonMode ? '0' : '6px')};
  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 32px;
  }
  .description-package {
    font-size: 14px;
    font-weight: 400;
    color: rgba(28, 28, 30, 0.64);
  }
`;

export const TagVoucherContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 4px 8px;
  border-radius: 8px;
  background-color: #fff4ed;
  border: 0.5px solid #ff9c66;
  min-height: 32px;
  box-sizing: border-box;
`;

export const TagVoucherText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #ff4405;
`;

export const TagVoucherImage = styled.img`
  width: 16px;
  height: 16px;
`;

export const EmptyTag = styled.div`
  height: 32px;
`;

export const PackageHeaderImage = styled.img`
  height: 32px;
`;

export const PackageName = styled.p`
  font-size: 24px;
  font-weight: 700;
  white-space: nowrap;
  margin: 0;
  color: ${({ $inDiscountTime }) => ($inDiscountTime ? '#FF5A12' : '#1C1C1E')};
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${({ isRow }) =>
    isRow &&
    `
    align-items: center;
    justify-content: center;
  `}
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: center;
`;

export const CurrencySign = styled.span`
  display: flex;
  align-items: center;
  line-height: 1;
  color: ${COLOR.darkBlue};
  font-size: 16px;
  font-weight: 510;
  ${({ isVietnam }) => isVietnam && 'text-decoration: underline;'}
  ${({ isRow }) => isRow && 'font-size: 20px;'}
`;

export const PriceMain = styled.span`
  font-weight: 800;
  color: ${COLOR.darkBlue};
  font-size: 40px;
`;

export const PriceSub = styled.span`
  margin-right: 6px;
  font-weight: 800;
  font-size: 20px;
  color: ${COLOR.darkBlue};
`;

export const PerYear = styled.span`
  font-size: 14px;
  color: rgba(28, 28, 30, 0.64);
  ${({ isRow }) => isRow && 'font-size: 20px;'}
`;

export const DiscountRow = styled.div`
  display: flex;
  height: 25px;
  align-items: center;
`;

export const OriginalCurrencySign = styled.span`
  color: rgba(0, 0, 0, 0.48);
  font-size: 14px;
  font-weight: 400;
  ${({ isVietnam }) => isVietnam && 'text-decoration: underline;'}
  ${({ isRow }) => isRow && 'font-size: 16px;'}
`;

export const OriginalPriceText = styled.span`
  text-decoration: line-through;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.48);
  font-size: 14px;
  ${({ isRow }) => isRow && 'font-size: 16px;'}
`;

export const OriginalPerYear = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.48);
  ${({ isRow }) => isRow && 'font-size: 16px;'}
`;

export const EmptyDiscount = styled.div`
  height: 25px;
`;
